import React from "react";

import ExportSalaries from "./ExportSalaries";
import ImportSalaries from "./ImportSalaries";

class BulkSalariesPage extends React.Component {
  render() {
    return (
      <div className="sub-content">
        <ExportSalaries />
        <hr />
        <ImportSalaries />
      </div>
    );
  }
}

export default BulkSalariesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/bulkSalaries/BulkSalariesPage.js